<template>
  <div class="admin-lead-show p-4 sm:p-6 lg:p-8">
    <!-- Header -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
      <div>
        <h1 class="text-3xl font-bold text-gray-900">Lead Details</h1>
        <p class="text-gray-600 mt-1">View detailed information about this lead</p>
      </div>
      <div class="flex items-center gap-2">
        <Link
          :href="route('admin.leads.index')"
          class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
        >
          Back to List
        </Link>
        <button
          @click="deleteLead"
          class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
        >
          Delete
        </button>
      </div>
    </div>

    <!-- Lead Information -->
    <div class="bg-white rounded-lg shadow-md border border-gray-200 p-6 mb-6">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Name</label>
          <p class="text-gray-900">{{ lead.name || 'N/A' }}</p>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <a :href="'mailto:' + lead.email" class="text-green-600 hover:text-green-800 hover:underline">
            {{ lead.email }}
          </a>
        </div>
        <div v-if="lead.profile" class="md:col-span-2">
          <label class="block text-sm font-medium text-gray-700 mb-1">Bio Page</label>
          <a
            :href="route('linkinbio.view', lead.profile.slug)"
            target="_blank"
            class="text-blue-600 hover:text-blue-800 hover:underline flex items-center gap-1"
          >
            {{ lead.profile.name }} ({{ lead.profile.slug }})
            <icon name="arrow-right" class="w-4 h-4" />
          </a>
        </div>
        <div v-if="lead.user" class="md:col-span-2">
          <label class="block text-sm font-medium text-gray-700 mb-1">Page Owner</label>
          <p class="text-gray-900">{{ lead.user.name }} ({{ lead.user.email }})</p>
        </div>
        <div v-if="lead.message" class="md:col-span-2">
          <label class="block text-sm font-medium text-gray-700 mb-1">Message</label>
          <p class="text-gray-900 whitespace-pre-wrap">{{ lead.message }}</p>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Created At</label>
          <p class="text-gray-900">{{ lead.created_at }}</p>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Last Updated</label>
          <p class="text-gray-900">{{ lead.updated_at }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link, router } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon.vue'
import Layout from '@/Shared/Layout'

export default {
  layout: Layout,
  components: {
    Link,
    Icon,
  },
  props: {
    lead: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: 'Lead Details',
    },
  },
  methods: {
    deleteLead() {
      if (confirm('Are you sure you want to delete this lead?')) {
        router.delete(route('admin.leads.destroy', this.lead.id), {
          onSuccess: () => {
            router.visit(route('admin.leads.index'))
            if (window.$toast) {
              window.$toast.success('Lead deleted successfully')
            }
          },
        })
      }
    },
  },
}
</script>

<style scoped>
.admin-lead-show {
  min-height: 100vh;
  background-color: #f9fafb;
}
</style>



